import { VALIDATION } from '@/constants'

/**
 * Validate a password against the application's strong password policy.
 * Returns an error message string if invalid, or an empty string if valid.
 */
export function validateStrongPassword(password) {
  if (!password) {
    return 'Password is required'
  }
  if (password.length < VALIDATION.MIN_PASSWORD_LENGTH) {
    return VALIDATION.PASSWORD_REQUIREMENTS_MESSAGE
  }
  if (!VALIDATION.PASSWORD_UPPERCASE_REGEX.test(password)) {
    return VALIDATION.PASSWORD_REQUIREMENTS_MESSAGE
  }
  if (!VALIDATION.PASSWORD_LOWERCASE_REGEX.test(password)) {
    return VALIDATION.PASSWORD_REQUIREMENTS_MESSAGE
  }
  if (!VALIDATION.PASSWORD_DIGIT_REGEX.test(password)) {
    return VALIDATION.PASSWORD_REQUIREMENTS_MESSAGE
  }
  if (!VALIDATION.PASSWORD_SPECIAL_REGEX.test(password)) {
    return VALIDATION.PASSWORD_REQUIREMENTS_MESSAGE
  }
  return ''
}
